import { createFileRoute } from '@tanstack/react-router';

import { HelplineDemandListScreen } from '@/features/helpline-demand/components/HelplineDemandListScreen';
import { forbidRoles, requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/app/helpline-demand/')({
  beforeLoad: () => {
    requirePermission('session:read');
    // Helpline demand is a psychologist surface only. Volunteers pass
    // session:read (via session:read_own) but must not see/act on it.
    forbidRoles(['volunteer']);
  },
  // Clinical surface: psychologists can mark clients followed up.
  component: ClinicalHelplineDemandRoute,
  staticData: { crumb: 'Helpline demand' },
});

function ClinicalHelplineDemandRoute() {
  return <HelplineDemandListScreen canMark />;
}
